import React, { useMemo, useState } from 'react';
import Header from '../components/header';
import '../styles/productos.css';
import aceiteImg from '../image/Productos/aceite.png';
import proteinaImg from '../image/Productos/proteina.png';
import alivinatuImg from '../image/Tiendas/Alivinatu.jpg';
import fullboostImg from '../image/Tiendas/Fullboost.jpg';
import bullstoreImg from '../image/Tiendas/Bull.jpg';
import { useLanguage } from '../context/LanguageContext';

const sectionOrder = ['beneficios', 'consumo', 'propiedades', 'recomendaciones'];

const contentByLanguage = {
  es: {
    eyebrow: 'Catalogo SAINZA',
    title: 'Descubre Nuestros Productos',
    subtitle: 'Nutricion inteligente con origen sostenible.',
    line: 'Linea oficial SAINZA',
    storesTitle: 'Donde encontrarnos',
    sectionLabels: {
      beneficios: 'Beneficios',
      consumo: 'Consumo',
      propiedades: 'Propiedades',
      recomendaciones: 'Recomendaciones'
    },
    products: [
      {
        id: 1,
        name: 'Aceite de Sacha Inchi',
        image: aceiteImg,
        description: '250 ml | Rico en Omega 3 y 6',
        sections: {
          beneficios: ['Salud cardiovascular', 'Antiinflamatorio natural', 'Hidratacion para la piel', 'Mejora la memoria'],
          consumo: ['10 ml en la manana o noche.', 'Como aderezo: ideal para ensaladas.', 'En batidos: agrega un toque nutritivo.'],
          propiedades: ['Rico en Omega 3 y 6.', 'Vitaminas A y E.', 'Minerales esenciales.'],
          recomendaciones: [
            'Tiene un punto de humo bajo (90C), por lo que no debe calentarse.',
            'Utilizalo en ensaladas, aderezos o preparaciones frias.',
            'Guardalo en un lugar fresco y oscuro para conservar su calidad.'
          ]
        }
      },
      {
        id: 2,
        name: 'Proteina Vegetal',
        image: proteinaImg,
        description: '500 gr | Alto contenido proteico',
        sections: {
          beneficios: ['Desarrollo muscular', 'Facil digestion', 'Rica en vitaminas', 'Ideal para deportistas'],
          consumo: {
            intro: 'Puedes mezclarla con agua, pero con leche o bebida vegetal enriquecida se aprovecha mejor.',
            reasons: [
              'Mejora la absorcion de aminoacidos esenciales.',
              'Aporta calcio y minerales para rendimiento fisico.',
              'Complementa el perfil de aminoacidos.',
              'Brinda energia sostenida y mayor saciedad.'
            ]
          },
          propiedades: ['Alto contenido proteico (32%).', 'Perfil de aminoacidos completo.', 'Rica en vitaminas y minerales.'],
          recomendaciones: ['Leche de vaca para mayor aporte proteico.', 'Bebida de soya enriquecida como mejor opcion vegetal.', 'Bebida de almendras o avena fortificada para opcion ligera.']
        }
      }
    ],
    stores: [
      { name: 'Alivinatu', href: 'https://www.instagram.com/alivinatu', image: alivinatuImg },
      { name: 'Fullboost', href: 'https://www.instagram.com/fullboost.ec', image: fullboostImg },
      { name: 'Bull Store', href: 'https://www.instagram.com/bullstoreloja', image: bullstoreImg }
    ]
  },
  en: {
    eyebrow: 'SAINZA Catalog',
    title: 'Discover Our Products',
    subtitle: 'Smart nutrition with a sustainable origin.',
    line: 'Official SAINZA line',
    storesTitle: 'Where to find us',
    sectionLabels: {
      beneficios: 'Benefits',
      consumo: 'Use',
      propiedades: 'Properties',
      recomendaciones: 'Recommendations'
    },
    products: [
      {
        id: 1,
        name: 'Sacha Inchi Oil',
        image: aceiteImg,
        description: '250 ml | Rich in Omega 3 and 6',
        sections: {
          beneficios: ['Cardiovascular support', 'Natural anti-inflammatory action', 'Skin hydration support', 'Memory support'],
          consumo: ['10 ml in the morning or evening.', 'As a dressing: perfect for salads.', 'In smoothies: adds a nutritious boost.'],
          propiedades: ['Rich in Omega 3 and 6.', 'Vitamins A and E.', 'Essential minerals.'],
          recomendaciones: [
            'It has a low smoke point (90C), so it should not be heated.',
            'Use it in salads, dressings, or cold preparations.',
            'Store in a cool and dark place to preserve quality.'
          ]
        }
      },
      {
        id: 2,
        name: 'Plant Protein',
        image: proteinaImg,
        description: '500 gr | High protein content',
        sections: {
          beneficios: ['Muscle development', 'Easy digestion', 'Rich in vitamins', 'Great for athletes'],
          consumo: {
            intro: 'You can mix it with water, but milk or fortified plant drinks improve absorption.',
            reasons: [
              'Improves essential amino acid uptake.',
              'Adds calcium and minerals for physical performance.',
              'Complements the amino acid profile.',
              'Provides sustained energy and satiety.'
            ]
          },
          propiedades: ['High protein content (32%).', 'Complete amino acid profile.', 'Rich in vitamins and minerals.'],
          recomendaciones: ['Cow milk for higher protein intake.', 'Fortified soy drink as top plant option.', 'Fortified almond or oat drink for a lighter option.']
        }
      }
    ],
    stores: [
      { name: 'Alivinatu', href: 'https://www.instagram.com/alivinatu', image: alivinatuImg },
      { name: 'Fullboost', href: 'https://www.instagram.com/fullboost.ec', image: fullboostImg },
      { name: 'Bull Store', href: 'https://www.instagram.com/bullstoreloja', image: bullstoreImg }
    ]
  }
};

const Productos = () => {
  const { language } = useLanguage();
  const copy = contentByLanguage[language];
  const [activeProductId, setActiveProductId] = useState(copy.products[0].id);
  const [activeSection, setActiveSection] = useState('beneficios');

  const currentProduct = useMemo(
    () => copy.products.find((product) => product.id === activeProductId) || copy.products[0],
    [activeProductId, copy.products]
  );

  return (
    <div className="productos-container page-shell">
      <Header />
      <div className="productos-main-content">
        <div className="productos-title-block">
          <p className="section-eyebrow">{copy.eyebrow}</p>
          <h1 className="productos-title">{copy.title}</h1>
          <p className="productos-subtitle">{copy.subtitle}</p>
        </div>

        <hr className="beneficios-separator" />

        <div className="product-selector" role="tablist" aria-label="Product selector">
          {copy.products.map((product) => (
            <button
              key={product.id}
              type="button"
              className={`product-chip ${activeProductId === product.id ? 'active' : ''}`}
              onClick={() => {
                setActiveProductId(product.id);
                setActiveSection('beneficios');
              }}
            >
              {product.name}
            </button>
          ))}
        </div>

        <section className="product-stage">
          <div className="product-stage-media">
            <span className="stage-glow"></span>
            <img
              src={currentProduct.image}
              alt={currentProduct.name}
              className={`product-stage-image ${currentProduct.id === 1 ? 'is-oil' : ''}`}
            />
          </div>

          <div className="product-stage-content">
            <p className="product-kicker">{copy.line}</p>
            <h2>{currentProduct.name}</h2>
            <p className="product-stage-description">{currentProduct.description}</p>

            <div className="section-tabs" role="tablist" aria-label="Section selector">
              {sectionOrder.map((section) => (
                <button
                  key={section}
                  type="button"
                  className={`section-tab ${activeSection === section ? 'active' : ''}`}
                  onClick={() => setActiveSection(section)}
                >
                  {copy.sectionLabels[section]}
                </button>
              ))}
            </div>

            <div className="section-panel">
              <h3>{copy.sectionLabels[activeSection]}</h3>
              {currentProduct.id === 2 && activeSection === 'consumo' ? (
                <>
                  <p className="section-intro">{currentProduct.sections.consumo.intro}</p>
                  <ul>
                    {currentProduct.sections.consumo.reasons.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                </>
              ) : (
                <ul>
                  {currentProduct.sections[activeSection].map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </section>

        <section className="tiendas-container">
          <h2 className="tiendas-title">{copy.storesTitle}</h2>
          <div className="tiendas-grid">
            {copy.stores.map((store) => (
              <a key={store.name} href={store.href} target="_blank" rel="noopener noreferrer" className="tienda-card">
                <img src={store.image} alt={store.name} className="tienda-image" />
                <h3>{store.name}</h3>
              </a>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Productos;
